import React from "react";
import { EmptyOrders } from "../../svgs";
import { Box, Stack, Typography } from "@mui/material";

const WorkOrdersOrdersEmpty = () => {
  return (
    <Stack gap="25px" margin="auto" alignItems="center">
      <Box component="img" src={EmptyOrders} sx={{ height: "150px" }} />
      <Stack gap="10px" alignItems="center" textAlign="center">
        <Typography variant="boldCaption">
          No Wor Orders Orders Found
        </Typography>
        <Typography variant="caption" maxWidth="400px">
          Your filters found no work orders, please try filtering for new
          conditions.
        </Typography>
      </Stack>
    </Stack>
  );
};

export default WorkOrdersOrdersEmpty;
